import React from 'react';
import useIntersectionObserver from './use-intersection-observer';
import pngToJpg from './png-to-jpg';

const LazyThumb = props => {

  const ref = React.useRef();
  const [isVisible, setIsVisible] = React.useState(false);
    
  useIntersectionObserver({
    target: ref,
    onIntersect: ([{ isIntersecting }], observerElement) => {
      if (isIntersecting) {
        setIsVisible(true);
        observerElement.unobserve(ref.current);
      }
    }
  });
  
  let imgSrc = props.src;
  if (imgSrc && props.pngToJpg) {
    imgSrc = pngToJpg(imgSrc);
  }
  const style = imgSrc ? { backgroundImage: 'url(\'' + imgSrc + '\')' } : {};
  return (<div ref={ref} onClick={props.onClick} className={props.className + (props.onClick ? ' clickable' : '')} style={isVisible ? style : {}}></div>);

};

export default LazyThumb;